// extracted by mini-css-extract-plugin
export default {"Container":"ErrorPasswordExceeded_Container__gM2AA","profileIcon":"ErrorPasswordExceeded_profileIcon__f+K-i","paraWrapper":"ErrorPasswordExceeded_paraWrapper__UUVv3"};